<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table" v-show="id < 0">
            <template #default="{row, property}">
                <el-link type="primary" :underline="false" @click="id = row['id']" v-if="property === 'name'">
                    {{row['name']}}
                </el-link>
                <p v-else-if="property === 'type'">{{$utils.getEnumLabel('user.type', row['type'])}}</p>
                <p v-else-if="property === 'status'">{{$utils.getEnumLabel('status', row['status'])}}</p>
            </template>
            <template #tools="{row}">
                <el-tooltip content="重置密码" placement="top">
                    <el-button type="text" icon="el-icon-refresh-right" size="small" @click="resetPass(row)"></el-button>
                </el-tooltip>
                <el-tooltip content="禁用" placement="top" v-if="row['status'] === 'ENABLE'">
                    <el-button type="text" icon="el-icon-turn-off" size="small" @click="toUpdate(row, 'DISABLE')"></el-button>
                </el-tooltip>
                <el-tooltip content="启用" placement="top" v-if="row['status'] === 'DISABLE'">
                    <el-button type="text" icon="el-icon-open" size="small" @click="toUpdate(row, 'ENABLE')"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                    <el-button type="text" icon="el-icon-delete" size="small" @click="toDel(row)"></el-button>
                </el-tooltip>
            </template>
        </RemoteTable>
        <Config :id="id" @close="close" v-if="id > -1"></Config>
    </div>
</template>
<script>
    import RemoteTable from "@/components/RemoteTable"
    import Config from "./Config.vue"

    export default {
        components: {
            RemoteTable,
            Config,
        },
        data() {
            return {
                id: -1,
                form: {
                    tools: [
                        {icon: "el-icon-plus", click: () => {this.id = 0;}}
                    ],
                    configs: [
                        {label: "用户名", name: "name", type: "input", op: "contains", value: ""},
                        {label: "状态", name: "status", type: "select", options: this.$utils.getEnumOptions("status"), value: ""},
                    ]
                },
                table: {
                    urlPrefix: "/user",
                    columns: [
                        {label: "用户名", name: "name"},
                        {label: "别名", name: "alias"},
                        {label: "状态", name: "status"},
                        {label: "创建时间", name: "createTime", sortable: true},
                        {label: "操作", name: "tools", width: 100},
                    ],
                }
            }
        },
        methods: {
            close(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            },
            resetPass(row) {
                this.$confirm("是否进行‘重置密码’操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    this.$axios.get('/user/resetpass/' + row.id).then(response => {
                        if (response['code'] === 0) {
                            this.$alert("密码已重置，新密码为：" + response.data, '提示', {
                                confirmButtonText: '确定'
                            });
                        } else {
                            this.$message.error(response['msg']);
                        }
                    })
                });
            },
            toDel(row) {
                this.$confirm("删除用户是不可逆操作，是否确认删除？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    this.$axios.get('/user/remove/' + row.id).then(response => {
                        if (response['code'] === 0) {
                            this.$message.success(this.$t("删除成功！"));
                            this.$refs.table.load();
                        } else {
                            this.$message.error(response['msg']);
                        }
                    })
                });
            },
            toUpdate(row, status) {
                this.$confirm("是否确认" + this.$utils.getEnumLabel('status', status) + row['name'] + "？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    let url;
                    if (status === "ENABLE") {
                        url = "/user/enable/"
                    } else if (status === "DISABLE") {
                        url = "/user/disable/"
                    }
                    this.$axios.get(url + row.id).then(response => {
                        if (response['code'] === 0) {
                            this.$refs.table.load();
                        }
                    })
                });
            }
        }
    }
</script>